export default __webpack_public_path__ + "static/media/dummyPerson.943e5fd6.jpg";